import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_88: FaireProductEntity = {
  token: "legacy_prod_abbott-88",
  type: "product",
  name: "Small Velvet Pouch with 3D Crown, Burgundy 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/45fbdb9e31ffb3646986585eba9627d36af49045d7ece597133687199a70839e.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
